import React from "react";

const UploadIcon: React.FC = () => {
  return (
    <>
      <svg
        width="30"
        height="27"
        viewBox="0 0 30 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mx-auto"
      >
        <path
          d="M10.2383 8.81845L14.9985 4.58008L19.7588 8.81845"
          stroke="#313131"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 15.8824V4.58008"
          stroke="#313131"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.9751 15.8828V21.534C24.9751 21.7481 24.8796 21.9534 24.7095 22.1048C24.5395 22.2562 24.3089 22.3413 24.0684 22.3413H5.93406C5.69358 22.3413 5.46296 22.2562 5.29291 22.1048C5.12287 21.9534 5.02734 21.7481 5.02734 21.534V15.8828"
          stroke="#313131"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default UploadIcon;
